/*
 * Copyright 2025 Inclusive Design Research Centre, OCAD University
 * All rights reserved.
 *
 * Licensed under the New BSD license. You may not use this file except in
 * compliance with this License.
 *
 * You may obtain a copy of the License at
 * https://github.com/inclusive-design/adaptive-palette/blob/main/LICENSE
 */

import { VNode } from "preact";
import { html } from "htm/preact";

export function ExportInputArea (): VNode {
  const cellClicked = (): void => {
    const container = document.getElementById("bmw-encoding-area");
    const svgs = container.querySelectorAll("svg");

    const canvas = document.createElement('canvas');
    canvas.width = container.offsetWidth;
    canvas.height = container.offsetHeight;
    const ctx = canvas.getContext('2d');

    const drawPromises = [...svgs].map((svg) => {
        return new Promise((resolve) => {
            const rect = svg.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            const svgData = new XMLSerializer().serializeToString(svg);
            const blob = new Blob([svgData], {type: 'image/svg+xml'});
            const url = URL.createObjectURL(blob);
            const img = new Image();
            img.onload = () => {
                ctx.drawImage(img, rect.left - containerRect.left, rect.top - containerRect.top);
                URL.revokeObjectURL(url);
                resolve();
            };
            img.src = url;
        });
    });

    Promise.all(drawPromises).then(() => {
        const link = document.createElement("a");
        link.download = 'export.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
    });
  };

  return html`
    <button
      class="btn-command"
      onClick=${cellClicked}>
      Download Image
    </button>
  `;
}
